import React from 'react';
import {
  withProductAccordion,
  IProductAccordionProps,
} from '@catalogo/service-americanas-product/src/hocs/product-accordion';
import { TAnchorRef } from '@catalogo/ui-americanas-mobile-accordion-box/src/types';
import ExpandButton from '@catalogo/ui-americanas-mobile-accordion-box/src/components/expand-button';
import { Container, Content, ContentWrapper, TitleContainer, TitleUI, ArrowIconUI, WrapperTitle } from './Styled';

export const DropDown: React.FC<IProductAccordionProps> = ({
  title,
  subTitle,
  htmlElTitle,
  children,
  forwardedRef,
  maxHeightCurrent,
  showExpandButton,
  toggleVisible,
  expandContent,
  isVisible,
  id,
  margin,
}) => (
  <Container margin={margin} id={id} className="product-review-dropdown">
    <TitleContainer onClick={toggleVisible} className="product-review-dropdown-title">
      <WrapperTitle className="product-review-dropdown-title-wrapper">
        <TitleUI $isVisible={isVisible} as={htmlElTitle as never} className="product-review-dropdown-title-text">
          {title}
        </TitleUI>
        <ArrowIconUI $isVisible={isVisible} className="product-review-dropdown-title-icon" />
      </WrapperTitle>
      {!isVisible && subTitle}
    </TitleContainer>
    <ContentWrapper
      ref={forwardedRef as React.ForwardedRef<HTMLDivElement>}
      style={{ maxHeight: maxHeightCurrent }}
      className="product-review-dropdown-content"
    >
      <Content>{children}</Content>
    </ContentWrapper>
    <ExpandButton showExpandButton={showExpandButton} expandContent={expandContent as () => void} />
  </Container>
);

DropDown.defaultProps = {
  paddingContentAxisX: 16,
  paddingTitleAxisX: 24,
  htmlElTitle: 'h3',
  anchorRef: '' as TAnchorRef,
};

export default withProductAccordion(DropDown);
